'use client';
import { objectEntries } from '@s7/utils';
import { Client } from './Client.js';
import { responseTypes } from '../domain/constants.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * Создаёт экземпляр Client, сразу выполняет запрос, выполняет все middleware.
 *
 * Прикрепляет к Promise<Response> body-методы, которые дополнительно устанавливают Accept-заголовок.
 * Это требует откладывать запрос на 1 проход событийного цикла. См. реализацию Client.execute.
 * */ const getDecoratedResponsePromise = (input, options)=>{
    const client = Client(input, options);
    const result = client.execute();
    /*
     * @note
     * `result` не требует декорирования `response.clone` в связи с тем,
     * что здесь мы декорируем Promise<Response>, а не сам Response
     * */ for (const [type, mimeType] of objectEntries(responseTypes)){
        result[type] = /*#__PURE__*/ _async_to_generator(function*() {
            if (!client.request.headers.has('accept')) {
                client.request.headers.set('accept', mimeType);
            }
            const awaitedResult = yield result;
            const response = awaitedResult.clone();
            if (type === 'json') {
                if (response.status === 204) {
                    return '';
                }
                const responseSize = (yield response.clone().arrayBuffer()).byteLength;
                if (responseSize === 0) {
                    return '';
                }
                if (options.parseJson) {
                    const text = yield response.text();
                    return options.parseJson(text);
                }
            }
            return response[type]();
        });
    }
    return result;
};

export { getDecoratedResponsePromise };
//# sourceMappingURL=getDecoratedResponsePromise.js.map
